<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="clock" class="icon"></b-icon>
            <span>เวลาทำการ</span>
            <button class="edit" @click="toggleEditStore()">
                <b-icon icon="pencil-fill"></b-icon>
            </button>
        </div>

        <div class="content">
            <div class="form" v-if="formData">
                <div class="row">
                    <div class="col-sm-12 col-lg-6" v-for="(item, index) in formData.time.opening" :key="index">
                        <div class="field-openning" :class="item.key">
                            <div class="input-checkbox">
                                <checkbox v-model="item.isOpen" :readonly="isEditStore ? false : true" @change="resetValue($event, item)">{{ item.day }}</checkbox>
                            </div>
                            <div class="time">
                                <div class="text text-right">เวลาเปิด</div>
                                <div class="value">
                                    <dropdown
                                        v-model="item.open"
                                        :options="option.time"
                                        :classes="{ input: ['input-field', (!isEditStore ? 'reader' : ''), (errorData[item.key].open.blank ? 'invalid' : '')] }"
                                        :disabled="(isEditStore ? false : true) || !item.isOpen"
                                    ></dropdown>
                                </div>
                                <div class="text text-right">เวลาปิด</div>
                                <div class="value">
                                    <dropdown
                                        v-model="item.close"
                                        :options="option.time"
                                        :classes="{ input: ['input-field', (!isEditStore ? 'reader' : ''), (errorData[item.key].close.blank ? 'invalid' : '')] }"
                                        :disabled="(isEditStore ? false : true) || !item.isOpen"
                                    ></dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3 text-right" v-if="isEditStore">
                    <button class="btn btn-main" @click="saveOpenTime()">บันทึก</button>
                    <button class="btn btn-grey-outline" @click="cancel()">ยกเลิก</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OptionTime from '@/database/staticOption/Time';
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isEditStore: false,
            displayData: null,
            formData: null,
            errorData: this.initValidateData(),
            option: { time: OptionTime.option }
        }
    },
    props: {
        fieldData: Object
    },
    watch: {
        fieldData(value) {
            this.setData(value);
        }
    },
    methods: {
        initValidateData() {
            return {
                mon: { open: { blank: false }, close: { blank: false } },
                tue: { open: { blank: false }, close: { blank: false } },
                wed: { open: { blank: false }, close: { blank: false } },
                thu: { open: { blank: false }, close: { blank: false } },
                fri: { open: { blank: false }, close: { blank: false } },
                sat: { open: { blank: false }, close: { blank: false } },
                sun: { open: { blank: false }, close: { blank: false } }
            }
        },
        toggleEditStore() {
            this.isEditStore = true;
        },
        setData(data) {
            this.displayData = data;
            this.formData = Helper.cloneObject(this.displayData);
        },
        resetValue(value, item) {
            if (!value) {
                item.open = '';
                item.close = '';
            }
        },
        saveOpenTime() {
            if (this.validateData()) {
                this.isEditStore = false;
                this.displayData = Helper.cloneObject(this.formData);

                this.$emit('saveData', {
                    group: 'time',
                    data: this.displayData
                });
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;
            
            this.formData.time.opening.forEach((item) => {
                if (item.isOpen && !item.open) {
                    this.errorData[item.key].open.blank = true;
                    valid = false;
                }

                if (item.isOpen && !item.close) {
                    this.errorData[item.key].close.blank = true;
                    valid = false;
                }
            });

            return valid;
        },
        cancel() {
            this.isEditStore = false;
            this.errorData = this.initValidateData();
            this.formData = Helper.cloneObject(this.displayData);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.field-openning {
    margin-top: -1px;
    padding: 20px;
    border-top: 1px dashed $textLightestColor;
    border-bottom: 1px dashed $textLightestColor;
    border-left-style: solid;
    border-left-width: 3px;
    border-left-color: #ccc;

    &.mon {
        border-left-color: #ffff00;
    }

    &.tue {
        border-left-color: #ffc0fb;
    }

    &.wed {
        border-left-color: #008000;
    }

    &.thu {
        border-left-color: #ffa500;
    }

    &.fri {
        border-left-color: #00bfff;
    }

    &.sat {
        border-left-color: #800080;
    }

    &.sun {
        border-left-color: #ff0000;
    }

    .input-checkbox {
        width: 150px;
        font-size: 14px;
        margin-bottom: 5px;
    }

    .input-field {
        padding-top: 5px;
        padding-bottom: 5px;

        &[readonly] {
            opacity: 0.5;
        }
    }

    .time {
        display: flex;
        align-items: center;

        .text {
            width: 50px;
            font-size: 14px;
            opacity: 0.5;
        }

        .value {
            width: 100px;
            margin: 0 20px;
        }
    }
}
</style>